export const doubleClickPreventionDebounceTime = 600.0
